import React from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const AdminSignOutButton = () => {
    const navigate = useNavigate();

    const handleSignOut = async () => {
        const auth = getAuth();
        await signOut(auth);
        navigate('/signin', { replace: true });
    };

    return (
        <button type="button" className="admin-signout-button" onClick={handleSignOut}>
            Sign Out
        </button>
    );
};

export default AdminSignOutButton;
